import axios from 'axios';
import { APP_CONSTANTS } from 'constants/app';

export enum WORKATO_PATH {
  PROJECTS = '/projects',
  COMMUNITY_LIBRARY = '/browse',
  ANALYTICS = '/dashboard',
}

type IframeTypes = 'full-page';

export const getWorkatoIframeUrl = ({ path }: { path: WORKATO_PATH }): Promise<{ type: IframeTypes; url: string }> => {
  const accountId = localStorage.getItem(APP_CONSTANTS.ACCOUNT_ID_LOCAL_KEY);

  return axios
    .get(`${window.location.origin}/connect/v1/workato/iframes/full-page?workatoPath=${path}`, {
      headers: {
        'x-sysaid-accountid': accountId,
      },
    })
    .then((response) => response.data)
    .then(({ data }) => data); // should be removed when backend is updated to avoid nested data object
};
